export const splitFlightCode = (flightCode) => {
  // Regex för att matcha bokstäver (flightPrefix) och siffror (flightNumber)
  const flightPrefix = flightCode.slice(0, 2); // De första två tecknen
  const flightNumber = flightCode.slice(2);

  return {
    flightPrefix,
    flightNumber,
  };
};
